import { memo } from 'react';
import type { PropsOf } from '~/shared/lib';
import { formatPrice } from './formatPrice';

type PriceProps = Omit<PropsOf<'span'>, 'children'> & { withoutCurrency?: boolean; children: number };

export const Price: React.FC<PriceProps> = memo(({ withoutCurrency = false, ...props }) => {
    return <span {...props}>{formatPrice(props.children, withoutCurrency)}</span>;
});
